import { Link } from 'react-router-dom'
import styles from './Margin.module.css'

export interface StandingState {
  place?: string | null
  present?: string | null
  time?: string | null
}

export default function Margin({
  standing,
  doing,
}: {
  standing: StandingState | null
  doing?: string | null
}) {
  const parts = [standing?.place, standing?.present].filter(Boolean) as string[]

  return (
    <div className={styles.margin}>
      <div className={styles.inner}>
        <Link to="/" className={styles.back} aria-label="Back to the shelf">
          ‹
        </Link>

        <div className={styles.standing}>
          {parts.map((p, i) => (
            <span key={p}>
              {i > 0 && <span className={styles.sep}>· </span>}
              {p}
            </span>
          ))}
          {standing?.time && <span className={styles.time}>{standing.time}</span>}
        </div>
      </div>

      {doing && <div className={styles.doing}>{doing}</div>}
    </div>
  )
}
